import classNames from "classnames"
import React from "react"

import { Color } from "../../../constants/V2/color"
import { IMAGE_URL } from "../../../constants/V2/salesForm"
import CheckBox from "../../elements/V2/Inputs/Checkbox"
import Typography from "../../elements/V2/Typography"

interface Props {
  touched: {
    [x: string]: string | boolean | undefined
  }
  errors: {
    [x: string]: string | boolean | undefined
    checkboxErrorMessage?: string
    radioErrorMessage?: string
  }
}

const RentalDeviceOptions = ({ touched, errors }: Props) => {
  const hasError =
    errors.checkboxErrorMessage &&
    (touched["Khumo"] || touched["Neo Touch"] || touched["Khumo Print"])

  return (
    <>
      <Typography
        color={Color.Black}
        text="3. Which Yoco product are you interested in renting? *"
        font="grotesk"
        size="body-lg"
        weight="medium"
        className="mb-8"
      />
      <Typography
        color={Color.Charcoal}
        text="You can only select 1 option below *"
        font="grotesk"
        size="body-md"
        weight="book"
        className={classNames(
          "mb-16",
          hasError ? "!text-orange opacity-100" : "opacity-70"
        )}
      />

      <div className="mb-32 flex flex-col flex-wrap gap-12 sm:flex-row">
        <div className="flex w-full flex-col gap-16 sm:w-[269px]">
          <CheckBox
            label="Neo Touch"
            id="Neo Touch"
            image={IMAGE_URL.yocoNeoTouch}
          />
          <CheckBox
            label="Khumo Print"
            id="Khumo Print"
            image={IMAGE_URL.yocoKhumoPrint}
          />
        </div>
        <div className="flex w-full flex-col gap-16 sm:w-[269px]">
          <CheckBox label="Khumo" id="Khumo" image={IMAGE_URL.yocoKhumo} />
        </div>
      </div>
    </>
  )
}

export default RentalDeviceOptions
